import { createAction, props } from '@ngrx/store';
import { SecurityProgramCoverages } from '../models/security-program';
import {
  Control,
  ControlDetails,
  Policy,
  PolicyDetails,
  Comment,
  TaskCoverage,
  TasksBySecurityDomain,
  ActivePolicy,
  PolicyStatus,
} from '../../../../../../shared/src/lib/core/interfaces';
import { SecurityDomainTableFilters } from './security-program.reducer';
import { TableSortDirection } from '../../../../../../shared/src/lib/modules/table/models/table';
import { baseProps } from 'projects/shared/src/lib/core/store/actions-base';

export const fetchSecureProgram = createAction(
  '[@diso/securityProgram] fetchSecureProgram',
  baseProps(),
);

export const fetchSecureProgram_Success = createAction(
  '[@diso/securityProgram] fetchSecureProgram_Success',
  props<{ coverage: SecurityProgramCoverages }>(),
);
export const fetchSecureProgram_Failure = createAction(
  '[@diso/securityProgram] fetchSecureProgram_Failure',
);

export const fetchSecurityScore = createAction(
  '[@diso/securityProgram] fetchSecurityScore',
);

export const fetchSecurityScore_success = createAction(
  '[@diso/securityProgram] fetchSecurityScore_success',
  props<{ score: any }>(),
);

export const fetchTasksCoverage = createAction(
  '[@diso/securityProgram] fetchTasksCoverage',
  baseProps(),
);

export const fetchTasksCoverage_success = createAction(
  '[@diso/securityProgram] fetchTasksCoverage_success',
  props<{ taskCoverage: TaskCoverage }>(),
);

export const showAllDomains = createAction(
  '[@diso/securityProgram] showAllDomains',
  props<{ showAll: boolean }>(),
);

export const fetchPoliciesCoverage = createAction(
  '[@diso/securityProgram] fetchPoliciesCoverage',
  baseProps(),
);

export const fetchPoliciesCoverage_success = createAction(
  '[@diso/securityProgram] fetchPoliciesCoverage_success',
  props<{ policies: Policy[] }>(),
);

export const fetchActivePolicies = createAction(
  '[@diso/securityProgram] fetchActivePolicies',
  baseProps(),
);

export const fetchActivePolicies_success = createAction(
  '[@diso/securityProgram] fetchActivePolicies_success',
  props<{ policies: ActivePolicy[] }>(),
);

export const fetchActiveControls = createAction(
  '[@diso/securityProgram] fetchActiveControls',
  baseProps<{ riskId?: string }>(),
);

export const fetchActiveControls_success = createAction(
  '[@diso/securityProgram] fetchActiveControls_success',
  props<{ activeControls: Control[] }>(),
);

export const removeLoadingTable = createAction(
  '[@diso/securityProgram] removeLoadingTable',
  props<{ tableName: string }>(),
);

export const selectControl = createAction(
  '[@diso/securityProgram] selectControl',
  props<{ control: Control }>(),
);

export const deselectControl = createAction(
  '[@diso/securityProgram] deselectControl',
);

export const selectPolicy = createAction(
  '[@diso/securityProgram] selectPolicy',
  props<{ policy: Policy }>(),
);

export const deselectPolicy = createAction(
  '[@diso/securityProgram] deselectPolicy',
);

export const fetchControlsByPolicyId = createAction(
  '[@diso/securityProgram] fetchControlsByPolicyId',
  baseProps<{ policyId: string }>(),
);

export const fetchControlsByPolicyId_success = createAction(
  '[@diso/securityProgram] fetchControlsByPolicyId_success',
  props<{ controls: Control[]; policyId: string }>(),
);

export const fetchControlsByPolicyId_failure = createAction(
  '[@diso/securityProgram] fetchControlsByPolicyId_failure',
);

export const changeControlStatus = createAction(
  '[@diso/securityProgram] changeControlStatus',
  props<{ controlId: string; policyId: string; state: string }>(),
);

export const changeControlStatus_success = createAction(
  '[@diso/securityProgram] changeControlStatus_success',
  props<{ control: Control; controlId: string }>(),
);

export const changeControlStatus_failure = createAction(
  '[@diso/securityProgram] changeControlStatus_failure',
  props<{ controlId: string }>(),
);

export const markControlsAsReviewed = createAction(
  '[@diso/securityProgram] markControlsAsReviewed',
  props<{ policyId: string; controlIds: string[] }>(),
);

export const markControlsAsReviewed_Success = createAction(
  '[@diso/securityProgram] markControlsAsReviewed_Success',
);

export const sortDomainTable = createAction(
  '[@diso/securityProgram] sortDomainTable',
  props<{
    column: keyof TasksBySecurityDomain;
    sortDirection: TableSortDirection;
  }>(),
);

export const filterDomainTable = createAction(
  '[@diso/securityProgram] filterDomainTable',
  props<{ key: keyof SecurityDomainTableFilters; value: string }>(),
);

export const toggleOpenTasks = createAction(
  '[@diso/securityProgram] toggleOpenTasks',
  props<{ showOpenTasks: boolean }>(),
);

export const fetchPolicyDetails = createAction(
  '[@diso/securityProgram] fetchPolicyDetails',
  baseProps<{ policyId: string; skipOpenIdCheck?: boolean }>(),
);

export const fetchPolicyDetails_Success = createAction(
  '[@diso/securityProgram] fetchPolicyDetails_Success',
  props<{ policyDetails: PolicyDetails }>(),
);

export const addPolicyComment = createAction(
  '[@diso/securityProgram] addPolicyComment',
  props<{ commentText: string; policyId: string }>(),
);

export const addPolicyComment_Success = createAction(
  '[@diso/securityProgram] addPolicyComment_Success',
  props<{ comment: Comment }>(),
);

export const removePolicyDetailsSidebar = createAction(
  '[@diso/securityProgram] removePolicyDetailsSidebar',
);

export const approvePolicy = createAction(
  '[@diso/securityProgram] approvePolicy',
  props<{ policyId: string; action: string; isActivePolicy?: boolean }>(),
);

export const approvePolicySuccess = createAction(
  '[@diso/securityProgram] approvePolicySuccess',
  props<{
    policyId: string;
    eligibleActions: string[];
    policyStatus: PolicyStatus;
  }>(),
);

export const approvePolicyFailure = createAction(
  '[@diso/securityProgram] approvePolicyFailure',
  props<{ policyId: string }>(),
);

export const updatePolicyStatus = createAction(
  '[@diso/securityProgram] updatePolicyStatus',
  props<{
    policyId: string;
    eligibleActions: string[];
    policyStatus: PolicyStatus;
  }>(),
);

export const fetchControlDetails = createAction(
  '[@diso/securityProgram] fetchControlDetails',
  props<{ controlId: string; bypassLoader?: boolean }>(),
);

export const fetchControlDetails_Success = createAction(
  '[@diso/securityProgram] fetchControlDetails_Success',
  props<{ controlDetails: ControlDetails }>(),
);

export const removeControlDetailsSidebar = createAction(
  '[@diso/securityProgram] removeControlDetailsSidebar',
);

export const addControlComment = createAction(
  '[@diso/securityProgram] addControlComment',
  props<{ commentText: string; controlId: string }>(),
);

export const addControlComment_Success = createAction(
  '[@diso/securityProgram] addControlComment_Success',
  props<{ comment: Comment }>(),
);

export const togglePolicyDetailsSidebar = createAction(
  '[@diso/securityProgram] togglePolicyDetailsSidebar',
  props<{ show: boolean }>(),
);

export const toggleControlDetailsSidebar = createAction(
  '[@diso/securityProgram] toggleControlDetailsSidebar',
  props<{ show: boolean }>(),
);

export const setControlDetailsCommentPending = createAction(
  '[@diso/securityProgram] setControlDetailsCommentPending',
  props<{ pending: boolean }>(),
);

export const setControlDetailsCommentFailed = createAction(
  '[@diso/securityProgram] setControlDetailsCommentFailed',
  props<{ failed: boolean; errorMessage?: string }>(),
);

export const setPolicyDetailsCommentPending = createAction(
  '[@diso/securityProgram] setPolicyDetailsCommentPending',
  props<{ pending: boolean }>(),
);

export const setPolicyDetailsCommentFailed = createAction(
  '[@diso/securityProgram] setPolicyDetailsCommentFailed',
  props<{ failed: boolean; errorMessage?: string }>(),
);
